import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { categoryList, categoryArticles, categoryMeta } from '@/mocks/category';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'wanghong-fanche';
  const meta = categoryMeta[currentSlug as keyof typeof categoryMeta];
  const currentCategory = categoryList.find((c) => c.slug === currentSlug);
  const articles = categoryArticles[currentSlug as keyof typeof categoryArticles] || [];

  const categoryName = currentCategory?.name || currentSlug;
  const articleCount = currentCategory?.articleCount || articles.length;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${categoryName} - 吃瓜51网`,
    description: meta?.description || '',
    url: 'http://jsqcyl.cn/',
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜51网',
      url: 'http://jsqcyl.cn/',
    },
  };

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://jsqcyl.cn/' },
      { '@type': 'ListItem', position: 2, name: categoryName, item: 'http://jsqcyl.cn/' },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLd) }}
        />

        <section className="relative w-full overflow-hidden pt-16">
          <div className="absolute inset-0">
            <img
              src={meta?.imageUrl || ''}
              alt={categoryName}
              className="w-full h-full object-cover object-top"
              title={categoryName}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          </div>
          <div className="relative max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col items-start justify-end min-h-[280px] md:min-h-[360px] pb-12 md:pb-16">
              <nav className="flex items-center gap-2 text-xs text-background-100/70 mb-4 flex-wrap">
                <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                  首页
                </Link>
                <span>/</span>
                <span className="text-background-50">{categoryName}</span>
              </nav>
              <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-3">
                {categoryName}
              </h1>
              <p className="text-sm md:text-base text-background-100/80 max-w-lg mb-4">
                {meta?.description}
              </p>
              <span className="text-xs text-background-100/60">
                共 {articleCount.toLocaleString()} 篇文章
              </span>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-10">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 mb-8 overflow-x-auto">
              {categoryList.map((cat) => (
                <Link
                  key={cat.slug}
                  to="/"
                  className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    currentSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard
                  key={article.slug}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={categoryName}
                  categorySlug={currentSlug}
                  imageUrl={article.imageUrl}
                  date={article.date}
                  readCount={article.readCount}
                  hotIndex={article.hotIndex}
                />
              ))}
            </div>

            {articles.length === 0 && (
              <div className="text-center py-20">
                <i className="ri-inbox-line text-5xl text-foreground-300 mb-4 block"></i>
                <p className="text-foreground-500">该分类暂无文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}